// Общее для связей (2026-09-08): связи проекта живут строками шаблона «Базовый».
// Раньше эта функция была только в экране «Работы»; теперь ею пользуется и
// карточка работы, где связь добавляют из выпадающего списка.
import { call } from './api';

/** id шаблона «Базовый» проекта; если его ещё нет — создаём. */
export async function ensureBaseTpl(pid: number): Promise<number | null> {
  const r = await call<{ id: number; name: string }[]>('get', '/api/link-templates?project=' + pid);
  if (!r.ok) return null;
  const t = r.data.find(x => x.name.toLowerCase() === 'базовый');
  if (t) return t.id;
  const c = await call<{ id: number }>('post', '/api/link-templates', { name: 'Базовый', project: pid });
  return c.ok ? c.data.id : null;
}
